<template>
  <v-container fluid class="pa-0">
    <v-card class="pa-2">
      <v-row>
        <v-col class="d-inline-flex">
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.shipper')"
                :value="houseBl.shipperName"
                :icon="'mdi-account-arrow-right'"
            />
          </v-col>
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.consignee')"
                :value="houseBl.consigneeName"
                :icon="'mdi-account-check'"
            />
          </v-col>
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.company')"
                :value="shippingLine?.supplierName && shippingLine?.supplierId ? `${shippingLine.supplierName} - ${shippingLine.supplierId}` : null"
                :icon="'mdi-account'"
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-inline-flex">
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.loadingNode')"
                :value="pratica.polLabel"
                :icon="'mdi-map-marker-outline'"
            />
          </v-col>
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.vessel')"
                :value="pratica.vesselName"
                :icon="'mdi-ferry'"
            />
          </v-col>
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.dischargeNode')"
                :value="pratica.podLabel"
                :icon="'mdi-map-marker-outline'"
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-inline-flex">
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.hbl')"
                :value="houseBl.billOfLading"
                :icon="'mdi-file-document-outline'"
            />
          </v-col>
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.booking')"
                :value="bookingNumber"
                :icon="'mdi-file-document-outline'"
            />
          </v-col>
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.freightTerms')"
                :value="houseBl.freightTerms"
                :icon="'mdi-file-document-outline'"
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-inline-flex">
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.clientFm')"
                :value="houseBl.clientFmName"
                :icon="'mdi-account'"
            />
          </v-col>
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.clientTo')"
                :value="houseBl.clientToName"
                :icon="'mdi-account'"
            />
          </v-col>
          <v-col class="pa-0"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-inline-flex">
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.shipperRef')"
                :value="houseBl.shipperRef"
                icon="mdi-file-document-edit-outline"
            />
          </v-col>
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.clientRef')"
                :value="houseBl.clientRef"
                icon="mdi-file-document-edit-outline"
            />
          </v-col>
          <v-col class="pa-0"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-inline-flex">
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.createDate')"
                :value="createDate"
                icon="mdi-calendar"
            />
          </v-col>
          <v-col class="pa-0">
            <ReadonlyField
                :label="$t('label.updateDate')"
                :value="updateDate"
                icon="mdi-calendar"
            />
          </v-col>
          <v-col class="pa-0"/>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="ma-0 mt-3">
      <v-tabs
          v-model="tab"
          background-color="accent"
          height="2rem"
          grow
      >
        <v-tab>{{ $t('label.tracking') }}</v-tab>
        <v-tab>{{ $t('label.containers') }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card class="px-2 pt-2">
            <v-row dense>
              <v-col class="d-inline-flex">
                <v-col class="pa-0">
                  <ReadonlyField
                      :label="$t('label.departure')"
                      :value="seaTrackingDeparture ? seaTrackingDeparture : houseBl.etd"
                      :icon="'mdi-calendar'"
                  />
                </v-col>
              </v-col>
              <v-col class="d-inline-flex">
                <v-col class="pa-0">
                  <ReadonlyField
                      :label="$t('label.arrival')"
                      :value="seaTrackingArrival ? seaTrackingArrival : houseBl.eta"
                      :icon="'mdi-calendar'"
                  />
                </v-col>
              </v-col>
            </v-row>
            <v-divider class="mt-2 mb-0"/>
            <v-data-table
                :headers="trackingHeadersMare"
                :items="seaTerminalEvents"
                :items-per-page="1000"
                hide-default-footer
                class="pa-0"
                dense
            >
              <template slot="no-data">
                <v-icon color="warning" class="mr-1" size="20">
                  mdi-alert
                </v-icon>
                <span class="font-weight-medium warning--text">
                          {{ $t('label.noTrackingInfo') }}
                        </span>
              </template>
              <template v-slot:item.eventDateTime="{ item }">
                {{ formatDateShort(item.eventDateTime) }}
              </template>
              <template v-slot:item.eventCode="{ item }">
                        <span :class="isDepartedFromPol(item) ? captionBoldClass : captionClass">
                          {{
                            item.eventCode === 'EST' ? 'ESTIMATED'
                                : item.eventCode === 'ACT' ? 'ACTUAL'
                                    : item.eventCode === 'PLN' ? 'PLANNED' : ''
                          }}
                        </span>
              </template>
              <template v-slot:item.eventName="{ item }">
                        <span :class="isDepartedFromPol(item) ? captionBoldClass : captionClass">
                          {{ item.eventName }}
                        </span>
              </template>
              <template v-slot:item.eventType="{ item }">
                        <span :class="isDepartedFromPol(item) ? captionBoldClass : captionClass">
                          {{ item.eventType }}
                        </span>
              </template>
              <template v-slot:item.eventDescription="{ item }">
                        <span :class="isDepartedFromPol(item) ? captionBoldClass : captionClass">
                          {{ item.eventDescription }}
                        </span>
              </template>
              <template v-slot:item.transportMode="{ item }">
                <div class="d-flex justify-center">
                  <v-icon v-if="item.transportMode === 'TRUCK'" color="primary">
                    mdi-truck
                  </v-icon>
                  <v-icon v-if="item.transportMode === 'VESSEL'" color="primary">
                    mdi-ferry
                  </v-icon>
                  <v-icon v-if="item.transportMode === 'RAIL'" color="primary">
                    mdi-train
                  </v-icon>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="px-2">
            <v-data-table
                :headers="imballiHeaders"
                :items="houseBl.containers"
                :search="imballiSearch"
                :items-per-page="1000"
                hide-default-footer
                class="pa-0"
                dense
            >
              <template v-slot:top>
                <v-text-field
                    v-model="imballiSearch"
                    :label="$t('label.search')"
                    append-icon="mdi-magnify"
                    class="ma-0 pa-0 text-caption"
                    single-line
                    hide-details
                />
              </template>
              <template slot="no-data">
                <v-icon color="warning" class="mr-1" size="20">
                  mdi-alert
                </v-icon>
                <span class="font-weight-medium warning--text">
                          {{ $t('label.noTrackingInfo') }}
                        </span>
              </template>
              <template v-slot:item.grossWeight="{ item }">
                {{ item.grossWeight }} {{ item.weightUOM }}
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import ReadonlyField from '@/components/elements/ReadonlyField.vue'
import Tracking from "../../../../mixins/Tracking";
import {dateFilter} from "../../../../filters/dateFilter";
import {suppliersService} from "../../../../services/suppliers.service";

export default {
  name: 'HouseBLMainTransportSea',
  props: ['houseBl'],
  mixins: [Tracking],
  components: {ReadonlyField},
  data() {
    return {
      tab: 0,
      imballiHeaders: [
        {text: this.$t('label.equipment'), value: 'equipmentReference'},
        {text: this.$t('label.quantity'), value: 'quantity'},
        {text: this.$t('label.grossWeight'), value: 'grossWeight'},
        {text: this.$t('label.item'), value: 'itemCode'},
        {text: this.$t('label.description'), value: 'itemDescription'},
      ],
      imballiSearch: null,
      shippingLine: {},
    }
  },
  methods: {
    init() {
      this.pratica = this.houseBl.masterBl
      this.getHouseBLSeaTracking(this.houseBl.id)
      this.getShippingLine()
    },
    getShippingLine() {
      if (!this.pratica.mainTransportCompany || !this.pratica.mainTransportCompany.length)
        return
      suppliersService
          .getSupplierBySupplierId(this.pratica.mainTransportCompany, this.pratica.tenantId)
          .then((resp) => {
            if (resp) this.shippingLine = resp
          })
    },
  },
  created() {
    this.init()
  },
  computed: {
    createDate() {
      return dateFilter.formatDateDay(this.houseBl.createDate)
    },
    updateDate() {
      return dateFilter.formatDateDay(this.houseBl.updateDate)
    },
    bookingNumber() {
      return this.houseBl?.containers?.[0]?.bookingNbr ?? ''
    }
  }

}
</script>

<style scoped>
.v-simple-checkbox .theme--light.v-icon {
  color: #005eb8 !important;
}

.v-simple-checkbox .v-input--selection-controls__input {
  margin: 0 !important;
}

.v-list--dense .v-subheader {
  height: fit-content !important;
}
</style>
